import { gql } from '@apollo/client';

export const CHANGE_PASSWORD_EMAIL = gql`
  mutation ChangePasswordByEmail($userId: ID!) {
    changePasswordByEmail(userId: $userId) {
      __typename
      ... on ChangePasswordByEmailSuccess {
        code
        message
      }
      ... on Error {
        message
        code
      }
    }
  }
`;
